import React from 'react';
import { Box, Grid, Typography, IconButton, SvgIcon } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import logo from "../../Assets/images/bigfive_logo.png"
import { fontFamilyall, GlobalHeaderColor, primaryColor } from '../UtilColorPalette/UtilColorPalette';

// Custom X Icon (Twitter new logo)
const XIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M22.46 2H18.6l-5.25 6.79L7.74 2H2l7.52 9.82L2.24 22h4.12l5.66-7.32L18.12 22h5.76l-7.76-10.15L22.46 2z" />
  </SvgIcon>
);
const linkStyle = {
  textDecoration: "none",
  color: "#555",
  "&:hover": {
    color: "#555", // optional hover effect
      textDecoration: "none",
  },
};
const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: GlobalHeaderColor,
        color: '#555',
        padding: { xs: '20px', sm: '30px', md: '40px' },
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'auto',
        borderTop: '1px solid #ccc',
      }}
    >
      <Grid
        container
        spacing={3}
        sx={{
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        {/* Logo and Description */}
        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', sm: 'flex-start' } }}>
            <Box
              component="img"
              src={logo}
              alt="BigFive CRM Logo"
              sx={{
                width: { xs: '120px', sm: '150px' },
                height: { xs: '120px', sm: '150px' },
                marginBottom: '10px',
              }}
            />
            <Typography
              variant="body2"
              fontFamily={fontFamilyall}
              textAlign={{ xs: 'justify', sm: 'justify' }}
              sx={{ maxWidth: '500px' }}
            >
              Big Five CRM is more compact, user-friendly package. It brings the power of
              enterprise-level CRM to every organization, ensuring they can compete with larger
              enterprises without the complexity and cost.
            </Typography>
          </Box>
        </Grid>

        {/* Menu */}
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6" gutterBottom color={primaryColor} textAlign={{ xs: 'center', sm: 'left' }} fontFamily={fontFamilyall}>
            MENU
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: { xs: 'flex-start', sm: 'flex-start' } }}>
            <Typography component="a" href="/"   variant="body1" fontFamily={fontFamilyall}  sx={linkStyle}>Home</Typography>
            <Typography component="a" href="https://bigfivecrm.com/about-us/"   variant="body1" fontFamily={fontFamilyall} sx={linkStyle}>About</Typography>
            <Typography component="a" href="https://bigfivecrm.com/blog/"   variant="body1" fontFamily={fontFamilyall} sx={linkStyle}>Blog</Typography>
            <Typography component="a" href="https://bigfivecrm.com/features/"   variant="body1" fontFamily={fontFamilyall} sx={linkStyle}>Features</Typography>
            <Typography component="a" href="https://bigfivecrm.com/pricing/"   variant="body1" fontFamily={fontFamilyall} sx={linkStyle}>Pricing</Typography>
            <Typography component="a" href="https://bigfivecrm.com/contact/"   variant="body1" fontFamily={fontFamilyall} sx={linkStyle}>Contact</Typography>
          </Box>
        </Grid>

        {/* Useful Links */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" gutterBottom color={primaryColor} textAlign={{ xs: 'left', sm: 'left' }} fontFamily={fontFamilyall}>
            USEFUL LINKS
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: { xs: 'center', sm: 'flex-start' } }}>
            <Typography component="a" href="https://bigfivecrm.com/contact/"  rel="noopener noreferrer" variant="body1" fontFamily={fontFamilyall}  sx={linkStyle}>Help & Support</Typography>
            <Typography component="a" href="https://bigfivecrm.com/contact/"  rel="noopener noreferrer" variant="body1" fontFamily={fontFamilyall} sx={linkStyle}>Request a Demo</Typography>
            <Typography component="a" href="/knowledgebase/"  rel="noopener noreferrer" variant="body1" fontFamily={fontFamilyall} sx={linkStyle}>Knowledge Base</Typography>
            <Typography component="a" href={"https://bigfivecrm.com/release-notes/"} rel="noopener noreferrer" variant="body1" fontFamily={fontFamilyall} sx={linkStyle}>Release Notes</Typography>
            <Typography component="a" href="https://bigfivecrm.com/partner-program/"  rel="noopener noreferrer" variant="body1" fontFamily={fontFamilyall} sx={linkStyle}>Partner Program</Typography>
          </Box>
        </Grid>

        {/* Social Media */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" gutterBottom color={primaryColor} textAlign={{ xs: 'left', sm: 'left' }} fontFamily={fontFamilyall}>
            CONNECT WITH US
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-start' }, gap: '10px' }}>
            <IconButton
              aria-label="LinkedIn"
              href="https://www.linkedin.com/company/big-five-crm/about/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "#0077b5",
                "&:hover": { backgroundColor: "#005582" },
                color: "#fff",
                borderRadius: "8px",
              }}
            >
              <LinkedInIcon />
            </IconButton>

            <IconButton
              aria-label="X"
              href="https://x.com/bigfivecrm"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "#000",
                borderRadius: "8px",
                "&:hover": { backgroundColor: "#111" },
              }}
            >
              <XIcon sx={{ color: "#fff", fontSize: 24 }} />
            </IconButton>

            <IconButton
              aria-label="Instagram"
              href="https://www.instagram.com/bigfivecrmtechnologies/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "#262626",
                borderRadius: "4px",
                width: "40px",
                height: "40px",
                "&:hover": { backgroundColor: "#000000" },
              }}
            >
              <InstagramIcon sx={{ color: "white", fontSize: 24 }} />
            </IconButton>

            <IconButton
              aria-label="YouTube"
              href="https://www.youtube.com/@BigFiveCRMTechnologies"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "red",
                borderRadius: "4px",
                width: "40px",
                height: "40px",
                "&:hover": { backgroundColor: "#cd201f" },
              }}
            >
              <YouTubeIcon sx={{ color: "white", fontSize: 24 }} />
            </IconButton>
          </Box>
        </Grid>
      </Grid>

      {/* Copyright Section */}
      <Box sx={{ textAlign: "center", marginTop: "30px" ,fontSize:'14px'}}>
        {/* <Typography  fontFamily={fontFamilyall}> */}
          Copyright © 2024 BigFiveCRM
        {/* </Typography> */}
      </Box>
    </Box>
  );
};

export default Footer;
